import { render, staticRenderFns } from "./ProjectWindow.vue?vue&type=template&id=5395f17b&scoped=true&lang=pug&"
import script from "./ProjectWindow.vue?vue&type=script&lang=ts&"
export * from "./ProjectWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5395f17b",
  null
  
)

export default component.exports